<template>
	<div>
		<div class="southpackagewrapper">
			<span class="title">{{title}}</span>
			<br /><br />
			<smdatepicker v-on:changed="datedepchanged"></smdatepicker>
			<button v-on:click="launchsearch">Chercher...</button>
			<br clear="all" />
		</div>

	</div>
</template>

<script>
import Vue from 'vue'
import smdatepicker from '@/components/smdatepicker.vue'

export default Vue.extend({
	name: 'southpackage',
	components: {smdatepicker},
	props: ['hotelnum', 'tourop', 'dest', 'title'],
	data() {
		return {
			cafr: {
				night: 'Nuit',
				nights: 'Nuits',
				'day-names': ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
				'check-in': 'Départ',
				'check-out': 'Retour',
				'month-names': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
				tooltip: {minimumRequiredPeriod: 'periode'}
			},
			searchurl: process.env.VUE_APP_SOFTVOYAGE_VED_URL,
			searchurljmv: process.env.VUE_APP_SOFTVOYAGE_JMV_URL,
			searchparams: {
				show_grid: 'Y',
				engines: 'S:G:D:E',
				searchtype: 'PA',
				dest_dep: 'Cubaxxx3,4,6,15,37,47,52,53,87,92,3049115,3049121',
				language: 'fr',
				price_min: '0',
				star_max: '',
				alias: '',
				code_ag: 'ved',
				gateway_dep: 'YUL',
				des_dep_pck_auto: 'Cuba',
				dest_dep_pck: '3,4,6,15,37,47,52,53,87,92,3049115,3049121',
				no_hotel: '1737,83',
				date_dep: '20210730',
				flex: 'Y',
				duration: '7',
				price_max: '',
				tour_to_display: '',
				max_wait: '300',
				star: '',
				Sorted_by: 'selling_price'
			},
			searchparamagent: {
				agent_id: '',
				agent_name: '',
				agent_email: '',
				agent_phone: '',
				agent_fax: ''
			},
			gotourl: ''
		}
	},

	mounted() {
		this.startapp()
	},

	methods: {
		startapp() {
			this.searchparams.no_hotel = this.hotelnum
			this.searchparams.dest_dep = this.dest
			this.searchparams.dest_dep_pck = this.dest
			this.searchparams.tour_to_display = this.tourop
			this.searchparams.alias = this.$store.state.agencyalias
			// console.log(this.hotelnum)
			// console.log('abc')
		},
		launchsearch() {
			// console.log(this.$store.state.agentid)
			if (this.searchparams.alias.toUpperCase() === 'WF3') {
				this.gotourl = this.searchurljmv + '?'
			} else {
				this.gotourl = this.searchurl + '?'
			}
			for (const key in this.searchparams) {
				if (!Object.prototype.hasOwnProperty.call(this.searchparams, key)) continue
				const obj = this.searchparams[key]
				this.gotourl = this.gotourl + key + '=' + obj + '&'
				// console.log(obj)
			}
			console.log(this.$store.state.mode)
			if (this.$store.state.mode === 'AGENT') {
				this.searchparamagent.agent_id = this.$store.state.agentinfos.agentid
				this.searchparamagent.agent_name = this.$store.state.agentinfos.firstname + ' ' + this.$store.state.agentinfos.lastname
				this.searchparamagent.agent_email = this.$store.state.agentinfos.email
				for (const key in this.searchparamagent) {
					if (!Object.prototype.hasOwnProperty.call(this.searchparamagent, key)) continue
					const obj = this.searchparamagent[key]
					this.gotourl = this.gotourl + key + '=' + obj + '&'
					// console.log(obj)
				}
			} else {
				// console.log('agency mode')
			}
			// console.log(this.gotourl)
			window.location = this.gotourl
		},
		datedepchanged(thedate) {
			// console.log(this.$store.state.agentinfos)
			this.searchparams.date_dep = thedate
		}
	}
})
</script>

<style scoped>
	.southpackagewrapper{
		background-color: #0085b2;
		padding-right: 10px;
		padding-left:10px;
		margin-top: 10px;
		margin-bottom: 10px;
		padding-bottom:10px;
		padding-top:10px;
		font-family: Open Sans;
		width: 450px;
		max-width: 100%;
	}
	button{
		margin-top:10px;
		left: 150px;
		padding: 10px;
		color:#fff;
		background-color: #00a2e9;
		border: solid 1px #FFF;
		cursor: pointer;
		font-family: Open Sans;
		float: right;
	}
	span.title{
		color:#FFF;
	}
</style>
